"use client";

import {
  uploadRagDocumentApi,
  listRagDocumentsApi,
  deleteRagDocumentApi,
  ragChatApi,
  downloadRagDocumentApi,
} from "../../services/api/ragChatApi";
import { useEffect, useRef, useState } from "react";
import "./ChatRoutePage.css";
// import {
//   IoSendSharp,
//   IoAddOutline,
//   IoCloudUploadSharp,
//   IoDocumentOutline,
//   IoTrashOutline,
// } from "react-icons/io5";
// import { FaRobot } from "react-icons/fa6";
import ReactMarkdown from "react-markdown";
import { toast, ToastContainer } from "react-toastify";
import {
  ACTIVE_CHAT_KEY,
  DOCUMENT_CHAT_STORAGE_KEY,
} from "../../utils/HelperFunction/Constants";
import {
  setEncryptedItem,
  getDecryptedItem,
  removeStorageItem,
} from "../../utils/storageUtils";
import LogoLoader from "../../components/UI/LogoLoader";

const IoSendSharp = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      d="M476.59 227.05l-.16-.07L49.35 49.84A23.56 23.56 0 0027.14 52 24.65 24.65 0 0016 72.59v113.29a24 24 0 0019.52 23.57l232.93 43.07a4 4 0 010 7.86L35.53 303.45A24 24 0 0016 327v113.31A23.57 23.57 0 0026.59 460a23.94 23.94 0 0013.22 4 24.55 24.55 0 009.52-1.93L476.4 285.94l.19-.09a32 32 0 000-58.8z"
      fill={color}
    />
  </svg>
);

const IoAddOutline = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 512 512"
    {...props}
  >
    <line
      x1="256"
      y1="112"
      x2="256"
      y2="400"
      stroke={color}
      strokeWidth="32"
      strokeLinecap="round"
    />
    <line
      x1="112"
      y1="256"
      x2="400"
      y2="256"
      stroke={color}
      strokeWidth="32"
      strokeLinecap="round"
    />
  </svg>
);

const IoCloudUploadSharp = ({
  size = 24,
  color = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      d="M473.66 210c-14-29.5-44.26-48.6-79.08-48.6a100.07 100.07 0 00-10.56.56 132.3 132.3 0 00-252.59 37.81C67.4 204.48 32 240.49 32 284.62c0 46.22 36.49 84.21 81.37 84.21h267.77c49.46 0 98.86-38.9 98.86-90.17a87.14 87.14 0 00-6.34-68.66z"
      fill={color}
    />
    <path
      d="M327 272.43l-63.5-58.51a11 11 0 00-15 0l-63.51 58.51A7.5 7.5 0 00190 285h42v68a7 7 0 007 7h34a7 7 0 007-7v-68h42a7.5 7.5 0 005.05-12.57z"
      fill="white"
    />
  </svg>
);

// IoDocumentOutline
const IoDocumentOutline = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      d="M428 224H288a48 48 0 01-48-48V36a4 4 0 00-4-4h-92a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V228a4 4 0 00-4-4z"
      fill="none"
      stroke={color}
      strokeLinejoin="round"
      strokeWidth="32"
    />
    <path
      d="M419.22 188.59L275.41 44.78a2 2 0 00-3.41 1.41V176a32 32 0 0032 32h129.81a2 2 0 001.41-3.41z"
      fill="none"
      stroke={color}
      strokeLinejoin="round"
      strokeWidth="32"
    />
  </svg>
);

// IoTrashOutline
const IoTrashOutline = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 512 512"
    {...props}
  >
    <polyline
      points="432 112 80 112"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
    />
    <path
      d="M192 112V72h128v40"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
    />
    <path
      d="M80 112l42 352h268l42-352"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
    />
    <line
      x1="256"
      y1="176"
      x2="256"
      y2="400"
      stroke={color}
      strokeLinecap="round"
      strokeWidth="32"
    />
    <line
      x1="192"
      y1="176"
      x2="208"
      y2="400"
      stroke={color}
      strokeLinecap="round"
      strokeWidth="32"
    />
    <line
      x1="320"
      y1="176"
      x2="304"
      y2="400"
      stroke={color}
      strokeLinecap="round"
      strokeWidth="32"
    />
  </svg>
);

const FaRobot = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 640 512"
    {...props}
  >
    <path
      d="M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm-16-96a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm192 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM576 167.8L528 200v112l48 32.2c15.1 10.1 35 5.9 45.1-9.2A32.1 32.1 0 00628 320V192c0-17.9-14.5-32.4-32.4-32.4-7.3 0-14.3 2.5-19.6 7.2zm-512 0c-5.3-4.7-12.3-7.2-19.6-7.2C26.5 160.6 12 175.1 12 193v128c0 6.5 1.9 12.8 5.4 18.2C27.5 354.1 47.4 358.3 62.5 348.2L112 316V200L64 167.8z"
      fill={color}
    />
  </svg>
);

export async function uploadRagDocument(file) {
  const response = await uploadRagDocumentApi(file);
  return response.data;
}

export async function listRagDocuments() {
  const response = await listRagDocumentsApi();
  return response.data;
}

export async function deleteRagDocument(docId, filename) {
  const response = await deleteRagDocumentApi(docId, filename);
  return response.data;
}

export async function ragChat(messages) {
  const response = await ragChatApi(messages);
  return response.data;
}

export async function downloadRagDocument(docId, filename) {
  const response = await downloadRagDocumentApi(docId, filename);
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

const loadSessions = () => {
  const sessions = getDecryptedItem(DOCUMENT_CHAT_STORAGE_KEY);
  return Array.isArray(sessions) ? sessions : [];
};

const saveSessions = (sessions) => {
  setEncryptedItem(DOCUMENT_CHAT_STORAGE_KEY, sessions);
};

const genId = () => crypto.randomUUID();

// ─── File Icon ────────────────────────────────────────────────────────────────
function FileIcon({ ext }) {
  const map = {
    PDF: { bg: "#fee2e2", color: "#dc2626" },
    DOC: { bg: "#dbeafe", color: "#2563eb" },
    DOCX: { bg: "#dbeafe", color: "#2563eb" },
    TXT: { bg: "#f3f4f6", color: "#6b7280" },
  };
  const c = map[ext?.toUpperCase()] || map.TXT;
  return (
    <div
      style={{
        width: "42px",
        height: "42px",
        borderRadius: "10px",
        flexShrink: 0,
        background: c.bg,
        color: c.color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "11px",
        fontWeight: "700",
      }}
    >
      {ext?.toUpperCase().slice(0, 3)}
    </div>
  );
}

// ─── Thinking Dots ────────────────────────────────────────────────────────────
function ThinkingDots() {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          style={{
            width: "6px",
            height: "6px",
            borderRadius: "50%",
            background: "#9ca3af",
            display: "inline-block",
            animation: "tdot 0.9s infinite",
            animationDelay: `${i * 0.15}s`,
          }}
        />
      ))}
      <style>{`@keyframes tdot{0%,80%,100%{transform:translateY(0)}40%{transform:translateY(-5px)}}`}</style>
    </div>
  );
}

// ─── Message Bubble ───────────────────────────────────────────────────────────
function MessageBubble({ message, isStreaming }) {
  if (message.role === "user") {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            background: "#f3f4f6",
            color: "#111827",
            padding: "12px 16px",
            borderRadius: "18px 18px 4px 18px",
            fontSize: "14px",
            lineHeight: "1.6",
            maxWidth: "65%",
          }}
        >
          {message.content}
        </div>
      </div>
    );
  }
  return (
    <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
      <div
        style={{
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          flexShrink: 0,
          background: "linear-gradient(135deg, #3C50B1, #8b5cf6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
        }}
      >
        <FaRobot size={18} />
      </div>
      <div
        style={{
          background: "#ffffff",
          color: "#374151",
          padding: "12px 16px",
          borderRadius: "4px 18px 18px 18px",
          fontSize: "14px",
          lineHeight: "1.6",
          border: "1px solid #f3f4f6",
          maxWidth: "75%",
        }}
      >
        {message.content === "" && isStreaming ? (
          <ThinkingDots />
        ) : (
          <ReactMarkdown>{message.content}</ReactMarkdown>
        )}
      </div>
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────
export default function ChatRoutePage() {
  const [sessions, setSessions] = useState(() => loadSessions());
  const [activeChatId, setActiveChatId] = useState(() =>
    getDecryptedItem(ACTIVE_CHAT_KEY),
  );
  const [isLoading, setIsLoading] = useState(false);
  const [streamingMsgId, setStreamingMsgId] = useState(null);
  const [input, setInput] = useState("");
  const [ragDocuments, setRagDocuments] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [isLoadingDocs, setIsLoadingDocs] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const [showRightPanel, setShowRightPanel] = useState(false);
  const [showLeftPanel, setShowLeftPanel] = useState(false);

  const messagesEndRef = useRef(null);
  const textareaRef = useRef(null);
  const fileInputRef = useRef(null);
  const dragCounterRef = useRef(0);

  const getSession = (id) => sessions.find((s) => s.id === id);

  const updateSessions = (updater) => {
    setSessions((prev) => {
      const updated = updater(prev);
      saveSessions(updated);
      return updated;
    });
  };

  const createSession = () => {
    const id = genId();
    const now = Date.now();
    const session = {
      id,
      title: "New Chat",
      messages: [],
      createdAt: now,
      updatedAt: now,
    };
    updateSessions((prev) => [session, ...prev]);
    return id;
  };

  const addMessage = (sessionId, message) => {
    updateSessions((prev) =>
      prev.map((s) =>
        s.id === sessionId
          ? { ...s, messages: [...s.messages, message], updatedAt: Date.now() }
          : s,
      ),
    );
  };

  const updateLastMessage = (sessionId, content) => {
    setSessions((prev) => {
      const updated = prev.map((s) => {
        if (s.id !== sessionId) return s;
        const messages = [...s.messages];
        const lastIndex = messages.length - 1;
        if (lastIndex >= 0 && messages[lastIndex].role === "assistant") {
          messages[lastIndex] = { ...messages[lastIndex], content };
        }
        return { ...s, messages, updatedAt: Date.now() };
      });
      saveSessions(updated);
      return updated;
    });
  };

  const updateSessionTitle = (id, title) => {
    updateSessions((prev) =>
      prev.map((s) => (s.id === id ? { ...s, title } : s)),
    );
  };

  useEffect(() => {
    if (activeChatId) setEncryptedItem(ACTIVE_CHAT_KEY, activeChatId);
    else removeStorageItem(ACTIVE_CHAT_KEY);
  }, [activeChatId]);

  useEffect(() => {
    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  }, [sessions]);

  useEffect(() => {
    loadDocuments();
  }, []);

  const loadDocuments = async () => {
    setIsLoadingDocs(true);
    try {
      const result = await listRagDocuments();
      const docs = result.documents.map((doc) => {
        const parts = doc.name.split("/");
        const docId = parts[0];
        const filename = parts[1];
        return {
          id: docId,
          docId,
          name: filename,
          ext: filename.split(".").pop(),
          size: `${Math.round(doc.size_kb)} KB`,
          time: new Date().toLocaleDateString(),
          fullName: doc.name,
        };
      });
      setRagDocuments(docs);
    } catch (error) {
      console.error("Failed to load documents:", error);
    } finally {
      setIsLoadingDocs(false);
    }
  };

  useEffect(() => {
    const prevent = (e) => e.preventDefault();
    window.addEventListener("dragover", prevent);
    window.addEventListener("drop", prevent);
    return () => {
      window.removeEventListener("dragover", prevent);
      window.removeEventListener("drop", prevent);
    };
  }, []);

  const uploadFiles = async (files) => {
    if (!files?.length) return;
    setIsUploading(true);

    for (const file of files) {
      try {
        const result = await uploadRagDocument(file);
        if (!result?.doc_id || !result?.filename) {
          toast.error(
            `Upload failed for ${file.name}: Invalid response from server`,
          );
        } else {
          setRagDocuments((prev) => [
            {
              id: result.doc_id,
              docId: result.doc_id,
              name: result.filename,
              ext: result.filename.split(".").pop(),
              size: `${Math.round(file.size / 1024)} KB`,
              time: "just now",
              chunksIndexed: result.chunks_indexed,
            },
            ...prev,
          ]);
          toast.success(`Uploaded ${file.name} successfully`);
        }
      } catch (error) {
        console.error("Upload failed:", error);
        toast.error(`Failed to upload ${file.name}: ${error.message}`);
      }
    }
    setIsUploading(false);
  };

  const handleFileUpload = async (e) => {
    const files = Array.from(e.target?.files || []);
    await uploadFiles(files);
    if (e.target) e.target.value = "";
  };

  const handleDeleteDocument = async () => {
    if (!fileToDelete) return;
    try {
      await deleteRagDocument(fileToDelete.docId, fileToDelete.name);
      setRagDocuments((prev) =>
        prev.filter((doc) => doc.id !== fileToDelete.id),
      );
      setShowDeleteModal(false);
      setFileToDelete(null);
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error(`Failed to delete: ${error.message}`);
    }
  };

  const handleNewChat = () => {
    const emptySession = sessions.find((s) => s.messages.length === 0);
    if (emptySession) {
      setActiveChatId(emptySession.id);
      return;
    }
    const id = createSession();
    setActiveChatId(id);
  };

  const handleSend = async () => {
    if (!input.trim() || isLoading || isUploading || ragDocuments.length === 0)
      return;

    let sessionId = activeChatId;
    if (!sessionId || !getSession(activeChatId)) {
      sessionId = createSession();
      setActiveChatId(sessionId);
    }

    const userText = input.trim();
    setInput("");
    if (textareaRef.current) textareaRef.current.style.height = "auto";

    addMessage(sessionId, { id: genId(), role: "user", content: userText });

    const assistantMsgId = genId();
    addMessage(sessionId, {
      id: assistantMsgId,
      role: "assistant",
      content: "",
    });
    setStreamingMsgId(assistantMsgId);
    setIsLoading(true);

    const session = getSession(sessionId);
    const sessionMessages =
      session?.messages?.filter((m) => m.content !== "") || [];
    if (sessionMessages.length === 0) {
      updateSessionTitle(
        sessionId,
        userText.slice(0, 38) + (userText.length > 38 ? "..." : ""),
      );
    }

    const history = (session?.messages || [])
      .filter((m) => m.content !== "")
      .map((m) => ({ role: m.role, content: m.content }));

    try {
      const response = await ragChat({
        messages: [...history, { role: "user", content: userText }],
      });
      let finalAnswer = response.answer;
      if (response.sources && response.sources.length > 0) {
        finalAnswer += `\n\n---\n**📚 Sources:** ${response.sources.join(", ")}`;
      }
      updateLastMessage(sessionId, finalAnswer);
    } catch (error) {
      console.error("Chat error:", error);
      updateLastMessage(sessionId, `❌ Error: ${error.message}`);
    } finally {
      setIsLoading(false);
      setStreamingMsgId(null);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const hasDraggedFiles = (e) =>
    Array.from(e.dataTransfer?.types || []).includes("Files");

  const handleDragEnter = (e) => {
    e.preventDefault();
    if (!hasDraggedFiles(e)) return;
    dragCounterRef.current += 1;
    setIsDragging(true);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    if (!hasDraggedFiles(e)) return;
    if (e.dataTransfer) e.dataTransfer.dropEffect = "copy";
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    dragCounterRef.current = Math.max(dragCounterRef.current - 1, 0);
    if (dragCounterRef.current === 0) setIsDragging(false);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!hasDraggedFiles(e)) return;
    dragCounterRef.current = 0;
    setIsDragging(false);
    await uploadFiles(Array.from(e.dataTransfer.files));
  };

  const activeSession = getSession(activeChatId);
  const messages = activeSession?.messages || [];
  const isEmpty = messages.length === 0;

  return (
    <div
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      className="chat-layout"
    >
      <ToastContainer />

      {/* Drag overlay */}
      {isDragging && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(99, 102, 241, 0.08)",
            outline: "2px dashed #3C50B1",
            outlineOffset: "-14px",
            zIndex: 1200,
            pointerEvents: "none",
          }}
        />
      )}

      {/* DELETE MODAL */}
      {showDeleteModal && fileToDelete && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={() => setShowDeleteModal(false)}
        >
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              width: "380px",
              padding: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "600",
                marginBottom: "8px",
              }}
            >
              Delete Document?
            </h3>
            <p
              style={{ fontSize: "14px", color: "#666", marginBottom: "20px" }}
            >
              Are you sure you want to delete "{fileToDelete.name}"?
            </p>
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "flex-end",
              }}
            >
              <button
                type="button"
                onClick={() => setShowDeleteModal(false)}
                style={{
                  padding: "8px 16px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  background: "white",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleDeleteDocument}
                style={{
                  padding: "8px 16px",
                  borderRadius: "6px",
                  border: "none",
                  background: "#dc2626",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── LEFT PANEL ── */}
      <div
        className={`chat-left-panel ${showLeftPanel ? "open" : ""}`}
        style={{ padding: "10px" }}
      >
        <button
          type="button"
          onClick={handleNewChat}
          style={{
            width: "100%",
            height: "35px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            padding: "10px",
            background: "#3C50B1",
            border: "none",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            color: "white",
          }}
        >
          <IoAddOutline size={17} />
          New Chat
        </button>

        <div style={{ flex: 1 }}>
          {sessions.length === 0 ? (
            <p
              style={{
                fontSize: "12px",
                color: "#9ca3af",
                padding: "8px 12px",
              }}
            >
              No chats found. Click "New Chat" to start a conversation.
            </p>
          ) : (
            sessions.map((session, index) => (
              <button
                type="button"
                key={`${session.id}-${index}`}
                onClick={() => {
                  setActiveChatId(session.id);
                  setShowLeftPanel(false);
                }}
                style={{
                  width: "100%",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  marginTop: "10px",
                  marginBottom: 0,
                  background:
                    session.id === activeChatId ? "#eef2ff" : "transparent",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                <svg
                  style={{ width: 14, height: 14, flexShrink: 0 }}
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M2 3h12v8H9l-3 2v-2H2V3z"
                    stroke="#9ca3af"
                    strokeWidth="1.5"
                  />
                </svg>
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#374151",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    flex: 1,
                  }}
                >
                  {session.title}
                </span>
              </button>
            ))
          )}
        </div>
      </div>

      {/* ── CENTER PANEL ── */}
      <div className="chat-center-panel">
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0 24px",
            height: "56px",
            background: "#ffffff",
            borderBottom: "1px solid #f3f4f6",
            flexShrink: 0,
          }}
        >
          {/* Mobile: Left menu button */}
          <div className="chat-mobile-header-left">
            <button
              className="chat-mobile-menu-btn"
              type="button"
              style={{ height: "35px" }}
              onClick={() => setShowLeftPanel(!showLeftPanel)}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </button>
          </div>

          {/* Centered Title */}
          <h1
            className="chat-mobile-title"
            style={{
              fontSize: "17px",
              fontWeight: "600",
              color: "#111827",
              margin: 0,
            }}
          >
            {activeSession?.title ?? "Document Chat"}
          </h1>

          {/* Mobile: Right knowledge base button */}
          <div className="chat-mobile-header-right">
            <button
              type="button"
              className={`chat-kb-toggle-btn ${showRightPanel ? "active" : ""}`}
              onClick={() => setShowRightPanel(!showRightPanel)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={14}
                height={14}
                viewBox="0 0 512 512"
                style={{ marginRight: "5px" }}
              >
                <path
                  d="M256 48a208 208 0 1 1 0 416A208 208 0 1 1 256 48zm0-48C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM135 241c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V376c0 13.3 10.7 24 24 24s24-10.7 24-24V219.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 107c-9.4-9.4-24.6-9.4-33.9 0L135 241z"
                  fill="currentColor"
                />
              </svg>
              Knowledge
            </button>
          </div>
        </div>

        {/* Messages */}
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            padding: "24px",
            background: "#f9fafb",
          }}
        >
          {isEmpty ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                gap: "10px",
                textAlign: "center",
              }}
            >
              <h2
                style={{
                  fontSize: "22px",
                  fontWeight: "700",
                  color: "#111827",
                }}
              >
                {ragDocuments.length === 0
                  ? "Upload documents to get started"
                  : "How can I help you today?"}
              </h2>
              <p style={{ fontSize: "12px", color: "#6b7280" }}>
                {ragDocuments.length === 0
                  ? "Add PDF, DOCX, or TXT files from the Knowledge Base panel"
                  : "Ask questions about your uploaded documents"}
              </p>
            </div>
          ) : (
            messages.map((msg) => (
              <MessageBubble
                key={msg.id}
                message={msg}
                isStreaming={msg.id === streamingMsgId && isLoading}
              />
            ))
          )}
          <div ref={messagesEndRef} />
        </div>

        {/* Input */}
        <div
          style={{
            padding: "10px 16px",
            background: "#ffffff",
            borderTop: "1px solid #f3f4f6",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              gap: "10px",
              padding: "10px 14px",
              borderRadius: "16px",
              background: "#f9fafb",
              border: `1px solid ${isUploading ? "#fca5a5" : "#e5e7eb"}`,
              minWidth: 0,
              overflow: "hidden",
              transition: "border-color 0.2s",
              cursor:
                isUploading || ragDocuments.length === 0
                  ? "not-allowed"
                  : "auto",
            }}
          >
            <textarea
              ref={textareaRef}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder={
                isUploading
                  ? "Please wait, document uploading..."
                  : ragDocuments.length === 0
                    ? "Upload a document first..."
                    : "Ask a question about your documents..."
              }
              rows={1}
              disabled={isLoading || isUploading || ragDocuments.length === 0}
              style={{
                flex: 1,
                resize: "none",
                background: "transparent",
                border: "none",
                outline: "none",
                fontSize: "14px",
                color: "#111827",
                lineHeight: "1.5",
                fontFamily: "inherit",
                minHeight: "40px",
                maxHeight: "160px",
                overflow: "hidden",
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                cursor:
                  isUploading || ragDocuments.length === 0
                    ? "not-allowed"
                    : "text",
              }}
            />
            <button
              type="button"
              onClick={handleSend}
              disabled={
                !input.trim() ||
                isLoading ||
                isUploading ||
                ragDocuments.length === 0
              }
              style={{
                width: "34px",
                height: "34px",
                borderRadius: "9px",
                border: "none",
                flexShrink: 0,
                cursor:
                  input.trim() &&
                  !isLoading &&
                  !isUploading &&
                  ragDocuments.length > 0
                    ? "pointer"
                    : "not-allowed",
                background:
                  input.trim() &&
                  !isLoading &&
                  !isUploading &&
                  ragDocuments.length > 0
                    ? "#3C50B1"
                    : "#e5e7eb",
                color:
                  input.trim() &&
                  !isLoading &&
                  !isUploading &&
                  ragDocuments.length > 0
                    ? "#ffffff"
                    : "#9ca3af",
              }}
            >
              <IoSendSharp size={14} />
            </button>
          </div>
          {isUploading && (
            <p
              style={{
                fontSize: "11px",
                color: "#dc2626",
                marginTop: "6px",
                paddingLeft: "4px",
              }}
            >
              ⏳ Document uploading — chat is disabled until upload completes.
            </p>
          )}
        </div>
      </div>

      {/* ── RIGHT PANEL ── */}
      <div
        className={`chat-right-panel ${showRightPanel ? "open" : ""}`}
        style={{
          background: isDragging ? "#f5f3ff" : "#ffffff",
          outline: isDragging ? "2px dashed #3C50B1" : "none",
          transition: "background 0.2s",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0 20px",
            height: "56px",
            borderBottom: "1px solid #f3f4f6",
            flexShrink: 0,
          }}
        >
          <h2 style={{ fontSize: "18px", fontWeight: "700" }}>
            Knowledge Base
          </h2>
        </div>

        <div style={{ padding: "14px 16px 10px" }}>
          <input
            ref={fileInputRef}
            type="file"
            multiple
            accept=".pdf,.doc,.docx,.txt"
            onChange={handleFileUpload}
            style={{ display: "none" }}
          />
          <button
            type="button"
            onClick={() => fileInputRef.current?.click()}
            disabled={isUploading}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "12px",
              borderRadius: "10px",
              border: "none",
              cursor: isUploading ? "not-allowed" : "pointer",
              background: "#3C50B1",
              color: "#ffffff",
              fontSize: "14px",
              fontWeight: "600",
              opacity: isUploading ? 0.7 : 1,
            }}
          >
            <IoCloudUploadSharp size={17} />
            {isUploading ? "Uploading..." : "+ Add Document"}
          </button>
        </div>

        <div style={{ padding: "4px 16px 16px" }}>
          <p
            style={{
              fontSize: "13px",
              fontWeight: "500",
              color: "#9ca3af",
              marginBottom: "12px",
            }}
          >
            Documents ({ragDocuments.length})
          </p>

          {isLoadingDocs ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection:"column",
              }}
            >
              <LogoLoader size={"sm"} duration="1s" />

              <p
                sx={{
                  fontSize: "14px",
                  color: "#64748B",
                  fontFamily:
                    "'Inter', 'Inter Fallback', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
                }}
              >
                Loading documents...
              </p>
            </div>
          ) : ragDocuments.length === 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100px",
                gap: "8px",
              }}
            >
              <IoDocumentOutline size={28} color="#d1d5db" />
              <p style={{ fontSize: "13px", color: "#9ca3af" }}>
                No documents yet
              </p>
              <p
                style={{
                  fontSize: "11px",
                  color: "#9ca3af",
                  textAlign: "center",
                }}
              >
                Upload PDF, DOCX, or TXT files
              </p>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "calc(100vh - 240px)",
                overflowY: "auto",
                paddingRight: "4px",
              }}
            >
              {ragDocuments.map((doc) => (
                <div
                  key={doc.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "12px",
                    borderRadius: "12px",
                    marginBottom: "6px",
                    border: "1px solid #f3f4f6",
                  }}
                >
                  <FileIcon ext={doc.ext} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#111827",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {doc.name}
                    </p>
                    <p
                      style={{
                        fontSize: "12px",
                        color: "#9ca3af",
                        marginTop: "2px",
                      }}
                    >
                      {doc.size} · {doc.time}
                      {doc.chunksIndexed && ` · ${doc.chunksIndexed} chunks`}
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => downloadRagDocument(doc.docId, doc.name)}
                    title="Download"
                    style={{
                      color: "#3C50B1",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: "4px",
                      display: "flex",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={15}
                      height={15}
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32z"
                        fill="#3C50B1"
                      />
                      <path
                        d="M64 352c-17.7 0-32 14.3-32 32v32c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v32H96V384c0-17.7-14.3-32-32-32z"
                        fill="#3C50B1"
                      />
                    </svg>
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setFileToDelete(doc);
                      setShowDeleteModal(true);
                    }}
                    style={{
                      color: "#dc2626",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: "4px",
                      display: "flex",
                    }}
                  >
                    <IoTrashOutline size={15} />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Overlays */}
      {showRightPanel && (
        <div
          className="chat-mobile-overlay"
          onClick={() => setShowRightPanel(false)}
        />
      )}
      
      {showLeftPanel && (
        <div
          className="chat-mobile-overlay"
          onClick={() => setShowLeftPanel(false)}
        />
      )}
    </div>
  );
}
